

/**
 * Takes a string with HTML entities within and renders it as the unicode
 * characters they represent. This is done by leveraging the browser to
 * perform this transformation internally. InnerText is chosen as the output
 * so as to kill any HTML itself that was supplied.
 *
 * @param {Element} element any HTML element supporting innerText and
 * innerHTML. Preferably one not connected to the DOM or visible in any way.
 * @param {String} input a String containing HTML entities that need to be
 * decoded and HTML stripped.
 * @return {String} the same string with HTML tags removed and entities
 * decoded.
 */

exports.__esModule = true;
exports.decodeEntities = decodeEntities;
exports['default'] = decodeEntitiesAngularFilter;
function decodeEntities(element, input) {
    element.innerHTML = input;
    return element.textContent || element.innerText;
}

function decodeEntitiesAngularFilter() {
    // A constant key that can be used to find the element
    var ENTITY_ELEM = '__xpc_entitydecoder__';

    // Create the element if this is the first time this is called
    if (!window[ENTITY_ELEM]) {
        window[ENTITY_ELEM] = document.createElement('p');
    }

    // Retrieve the converter element rather than create one every
    // time. Angular may call this filter many times repeatedly and
    // we should make a small effort to optimize the process
    var converter = window[ENTITY_ELEM];

    /**
     * Takes a string with HTML entities within and renders it as the unicode
     * characters they represent. This is done by leveraging the browser to
     * perform this transformation internally. InnerText is chosen as the output
     * so as to kill any HTML itself that was supplied.
     *
     * @param {String} input a String containing HTML entities that need to be
     * decoded and HTML stripped.
     * @return {String} the same string with HTML tags removed and entities
     * decoded.
     */
    return decodeEntities.bind(null, converter);
}


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/cart/lib/decode_entities.js
// module id = ./components/xo-page-components/src/cart/lib/decode_entities.js
// module chunks = 1